<div class="submitsuccess-popup">
    <button class="pop-cls-btn" mat-dialog-close><img src="assets/img/detail-close-icon.svg" class="icon" /></button>
    <div class="submitsuccess-animate-icon-area">
        <!-- <img src="assets/img/animation-champion-icon.gif" class="submitsuccess-animate-icon m-hide" /> -->
        <img src="assets/img/animation-report-icon.gif" class="submitsuccess-animate-icon" />
    </div>
    <h5 class="submitsuccess-heading">Well Done!</h5>
    <h6 class="submitsuccess-normal-text">You've successfully submitted the test</h6>

    <div class="UNFAPP-btnwrp">
        <button class="btn UNFAPP-blue-btn UNFAPP-full-btn" type="button" mat-dialog-close>VIEW SOLUTION</button>
    </div>

</div>